define('businessServices/router/plugins/signupRetiredRouteRedirectPlugin',[
        'constants/signupSessionFlowConstants',
        'settings/navigationConfiguration'
    ],
    function() {
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _signupSessionFlowConstants = require('constants/signupSessionFlowConstants');

        const ROUTE__SIGNUP_EMAIL = _navigationConfiguration.routesById.signupEmail;
        const ROUTE__SIGNUP_EMAIL_VERIFY = _navigationConfiguration.routesById.signupEmailVerify;
        const ROUTE__SIGNUP_PLANS = _navigationConfiguration.routesById.signupPlans;

        const _buildUrl = (url, flowId) => url.replace(":flow", flowId);

        // Rewritten before route resolution rather than in a route guard: the guard only creates a
        // signup session for a flow start, so a new visitor on a retired URL would reach it with no
        // session and be sent to sign-in.
        const REDIRECTS = [_signupSessionFlowConstants.flowA, _signupSessionFlowConstants.flowAgent]
            .reduce((redirects, flowId) => {
                const plansUrl = _buildUrl(ROUTE__SIGNUP_PLANS.url, flowId);
                redirects[_buildUrl(ROUTE__SIGNUP_EMAIL.url, flowId).toLowerCase()] = plansUrl;
                redirects[_buildUrl(ROUTE__SIGNUP_EMAIL_VERIFY.url, flowId).toLowerCase()] = plansUrl;
                return redirects;
            }, {});

        function signupRouteRedirect(urlFragment) {
            const queryIndex = urlFragment.indexOf("?");
            const path = (queryIndex === -1 ? urlFragment : urlFragment.substring(0, queryIndex))
                .replace(/^\//, "")
                .replace(/\/$/, "");

            // Durandal matches routes case-insensitively
            const redirectUrl = REDIRECTS[path.toLowerCase()];
            if (redirectUrl === undefined) {
                return true;
            }

            // Affiliate and package deep links ride on the query string.
            const queryString = queryIndex === -1 ? "" : urlFragment.substring(queryIndex);
            return {routeUrl: redirectUrl + queryString};
        }

        return {
            loadUrlRedirect: signupRouteRedirect
        };
    });

